import { RETAILER_ENABLE_STANDARDIZE_ORDER_NUMBERS_240812 } from "@faire/web-api--source/indigofair/settings/RETAILER_ENABLE_STANDARDIZE_ORDER_NUMBERS_240812";

import { useSetting } from "./useSetting";

export const useSettingRetailerEnableStandardizeOrderNumbers = (): boolean => {
  return useSetting(RETAILER_ENABLE_STANDARDIZE_ORDER_NUMBERS_240812, true);
};
